import * as React from 'react';
type Props = {
  className?: string;
};
export function AntiInflamitory({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-AntiInflamitory"
      className={className}
    >
      <g clipPath="url(#clip0_8392_22279)">
        <path
          d="M10.793 29.2523L6.63343 33.4119M33.3618 6.68355L21.4966 18.5488M38.9176 21.7095C37.9785 32.1672 28.7339 39.8706 18.2868 38.9208C9.76038 38.1505 3.05948 31.8506 1.40273 23.8834C1.02284 22.0895 0.906756 20.2006 1.0756 18.28C1.65599 11.8851 5.33885 6.51381 10.5096 3.53798C13.781 1.64907 17.6537 0.709885 21.7059 1.07923C32.1635 2.01841 39.8568 11.2624 38.9176 21.7095ZM16.4174 33.0642C7.01502 30.4893 10.2969 21.5934 12.9667 18.28C15.4888 15.1564 17.9158 14.3754 17.4621 8.39219C17.3566 7.04145 17.1033 3.80181 19.4565 8.64545C21.2188 12.265 20.0475 19.0819 22.5484 20.0739C23.5826 20.4854 24.7117 20.0739 25.3449 19.2191C26.3052 17.9317 26.1363 16.4227 26.5795 16.9398C32.0458 23.3346 27.5187 36.1139 16.4068 33.0747L16.4174 33.0642ZM17.937 33.1802C12.513 31.5023 16.755 20.802 17.6731 22.7753C18.4329 24.4005 19.161 26.817 21.1239 25.2552C23.7831 23.1341 24.8489 35.3223 17.937 33.1802Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_8392_22279">
          <rect width={40} height={40} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
